import React, { useState } from "react";
import "../VerifyMobile/verifyMobileEmail.css";
import EnterEmailOtp from "../OTP/EmailOtp/EnterEmailOtp";
import EnterMobileOtp from "../OTP/MobileOtp/EnterMobileOtp";
import SetPassWord from "../../Registration/SetPassWord/SetPassWord";
import axios from "../../../axios";

export default function VerifyMobileEmail({
  registerState,
  isVailidatedEmail,
}) {
  const [isEmailValidated, setIsEmailValidated] = useState(false);
  const [iswait, setIsWait] = useState(false);
  // const [isMobileValidated, setIsMobileValidated] = useState(false);
  const emailId = JSON.parse(localStorage.getItem("Email"));
  const schoolCode = localStorage.getItem("schoolCode");
  const schoolAssignedId = localStorage.getItem("schoolAssignedId");
  const [verifymail, setVerifymail] = useState();
  // const [verifyMobile, setVerifyMobile] = useState();
  const [password, SetPassword] = useState();
  const contactNo = JSON.parse(localStorage.getItem("Mobile_no"));
  const handleVerifyemail = async () => {
    setIsWait(true);
    try {
      await axios.post("/api/v1/teacherAuth/generateEmailOtp", {
        school_assigned_id: schoolAssignedId,
        school_code: schoolCode,
      });
      setVerifymail(true);
      setIsWait(false);
    } catch (error) {
      console.log(error);
    } finally {
      setIsWait(false);
    }
  };
  const MaskedEmail = (email) => {
    const maskEmail = (email) => {
      if (!email || typeof email !== "string") return email;

      const [localPart, domain] = email.split("@");
      if (!localPart || !domain) return email;

      // Mask local part
      const firstPart = localPart.slice(0, 2);
      const maskedLocalMiddle = "*".repeat(Math.max(localPart.length - 4, 5));
      // const lastPart = localPart.slice(-1);

      // Mask domain
      const [domainName, domainExtension] = domain.split(".");
      const maskedDomainMiddle = "*".repeat(Math.max(domainName.length - 2, 3));
      // const firstDomainPart = domainName.slice(0, 1);
      const lastDomainPart = domainName.slice(-1);

      const maskedDomain = `${maskedDomainMiddle}${lastDomainPart}.${domainExtension}`;

      return `${firstPart}${maskedLocalMiddle}@${maskedDomain}`;
    };

    return <span>{maskEmail(email)}</span>;
  };

  const maskPhoneNumber = (phone) => {
    if (!phone) return "";

    const phoneStr = phone.toString();

    // Show first 2 and last 2 digits
    return (
      phoneStr.slice(0, 2) +
      "*".repeat(phoneStr.length - 4) +
      phoneStr.slice(-2)
    );
  };
  //This code is part of verify mobile no with otp
  // const handleVerifyMobile = async () => {
  //   try {
  //     await axios.post("/api/v1/teacherAuth/generateMobileOtp", {
  //       mobile_number: contactNo,
  //     });
  //     setVerifyMobile(true);
  //   } catch (error) {
  //   }
  // }

  return (
    <>
      <div>
        {!verifymail && !password && (
          <div className="TotalContainer d-md-flex ">
            <div className="banner_box col-md-3 col-12 p-0">
              <img
                className="banner_img "
                src="/Register-img/baner_img.jpg"
                alt="banner img"
              ></img>
            </div>

            <div className="form_box col-md-9 col-12 p-0">
              <div>
                <div className="total_logo_regist">
                  <img
                    className="logo_registration"
                    src="/Register-img/Register_logo.png"
                    alt="register logo"
                  ></img>
                </div>
                <div className="verify_title">Verify Email & Mobile Number</div>

                <div className="verify_input_container">
                  {/* <div id="enterEmail">
                    <div>
                      <div className="verifyEmail">Verify Email ID</div>
                      <div className="verifyEmail2">
                        {MaskedEmail(registerState.emailid)}
                      </div>
                    </div>

                    <span
                      onClick={(e) => {
                        handleVerifyemail();
                      }}
                      className="Verify_now"
                    >
                      {!isEmailValidated ? (
                        <span className="Verify_now">Verify now</span>
                      ) : (
                        <img
                          src="/Register-img/Right_icon.svg"
                          alt="varify logo"
                        ></img>
                      )}
                    </span>
                  </div> */}
                  <div className="min-vh-75 d-flex align-items-center justify-content-center bg-light px-2">
                    <div className="text-center" style={{ width: "500px" }}>
                      {/* Card */}
                      <div
                        className="bg-white border rounded-4 p-4 mt-2 shadow-sm"
                        style={{ borderColor: "#9db3c7" }}
                      >
                        {/* Mobile Number */}
                        <div className="text-start">
                          <label
                            className="fw-semibold mb-2 d-block"
                            style={{ fontSize: "18px", color: "#4b5563" }}
                          >
                            Mobile Number
                          </label>

                          <div
                            className="border rounded-4 px-2 py-2 fw-medium text-dark"
                            style={{
                              borderColor: "#9db3c7",
                              fontSize: "18px",
                            }}
                          >
                            +91 {maskPhoneNumber(registerState?.contactN)}
                          </div>
                          <span style={{ color: "red" }}>
                            {!registerState?.contactN &&
                              "Mobile number is not registered!!"}
                          </span>
                        </div>

                        {/* Email ID */}
                        <div className="text-start mt-4">
                          <label
                            className="fw-semibold mb-2 d-block"
                            style={{ fontSize: "18px", color: "#4b5563" }}
                          >
                            Email ID
                          </label>

                          <div
                            className="border rounded-4 px-2 py-2 fw-medium text-dark"
                            style={{
                              borderColor: "#9db3c7",
                              fontSize: "18px",
                            }}
                          >
                            {MaskedEmail(registerState?.emailid)}
                          </div>
                          <span style={{ color: "red" }}>
                            {!registerState?.emailid &&
                              "Email Id is not registered!!"}
                          </span>
                        </div>

                        {/* Button */}
                        {!isEmailValidated && (
                          <button
                            className="btn w-100 text-white fw-bold mt-5 rounded-4"
                            disabled={
                              !registerState?.emailid &&
                              !registerState?.contactN
                            }
                            onClick={() => handleVerifyemail()}
                            style={{
                              backgroundColor: "#ff8800",
                              padding: "14px",
                              fontSize: "18px",
                              fontWeight: "500",
                            }}
                          >
                            {iswait ? "Please wait..." : "Verify Now"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* Here I commented code hide the option for verify mobile no with otp*/}

                  {isEmailValidated && (
                    <button
                      class="btn btn col-12"
                      id="verify_btn"
                      onClick={(e) => {
                        SetPassword(true);
                      }}
                      type="button"
                    >
                      Continue
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {verifymail && (
          <EnterEmailOtp
            setVerifymail={setVerifymail}
            setIsEmailValidated={setIsEmailValidated}
            registerState={registerState}
          />
        )}
        {/* Commented for verify with mobile otp */}
        {/* {verifyMobile && (
          <EnterMobileOtp
            setVerifyMobile={setVerifyMobile}
            setIsMobileValidated={setIsMobileValidated}
            registerState={registerState}
          />
        )} */}
        {password && <SetPassWord registerState={registerState} />}
      </div>
    </>
  );
}
